import api from "@/api";

import deepClone from "@/utils/deep-clone";

const DEFAULT_MAX_CUSTOM_BADGES = 12;

const state = {
    list: [],
    max: DEFAULT_MAX_CUSTOM_BADGES,
};

const getters = {
    list(state) {
        return deepClone(state?.list ?? []);
    },
    max(state) {
        return state?.max ?? DEFAULT_MAX_CUSTOM_BADGES;
    },
    custom(state) {
        const list = state?.list ?? [];
        const customBadges = list.filter(badge => badge.default !== true);

        return deepClone(customBadges);
    },
    details(state) {
        return ({ id }) => deepClone(state?.list?.find(badge => badge._id === id) || {});
    },
};

const actions = {
    getList({ commit }) {
        return api.get("/api/badges").then(res => {
            const list = res?.data?.badges ?? [];
            const max = res?.data?.maxCustomBadges ?? DEFAULT_MAX_CUSTOM_BADGES;

            commit("updateList", { list });
            commit("updateMax", { max });
        });
    },
    get({ commit, state }, { payload: { id } }) {
        return api.get(`/api/badges/${id}`).then(res => {
            const badge = res?.data?.badge;
            const list = getters.list(state);

            if (!badge) {
                return;
            }

            const index = list.findIndex(el => el._id === badge._id);
            if (index < 0) {
                list.push(badge);
            } else {
                list[index] = badge;
            }

            commit("updateList", { list });
        });
    },
    create({ commit, state }, { payload: { badge } }) {
        return api.post("/api/badges", { badge }).then(res => {
            const badge = res?.data?.badge;
            const list = getters.list(state);
            const max = getters.max(state);

            if (!badge || list.length >= max) {
                return;
            }

            list.push(badge);
            commit("updateList", { list });
        });
    },
    upload(_, { payload: { file } }) {
        const formData = new FormData();
        formData.append("file", file);

        return api.post("/api/uploads/badge", formData).then(res => {
            const picture = res?.data?.picture;

            return picture;
        });
    },
    update({ commit, state }, { payload: { id, badge } }) {
        return api.put(`/api/badges/${id}`, { badge }).then(res => {
            const badge = res?.data?.badge;
            const list = getters.list(state);

            if (!badge) {
                return;
            }

            const index = list.findIndex(el => el._id === badge._id);
            list[index] = badge;

            commit("updateList", { list });
        });
    },
    delete({ commit, state }, { payload: { id } }) {
        return api.delete(`/api/badges/${id}`).then(() => {
            const list = getters.list(state);
            const index = list.findIndex(el => el._id === id);

            list.splice(index, 1);

            commit("updateList", { list });
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
    updateMax(state, { max = DEFAULT_MAX_CUSTOM_BADGES }) {
        state.max = max;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

export { DEFAULT_MAX_CUSTOM_BADGES };
